import axios from "axios";
import type { ColdSimulation, RotSimulation } from "./types";
import { env } from "../../config";

const API_RMKT_URL = env.pubSub.apiRMKT;

const apiRMKTService = axios.create({
	baseURL: API_RMKT_URL,
	headers: {
		"Content-Type": "application/json",
	},
});

export const RMKTColdSimulation = async (data: ColdSimulation): Promise<void> => {
	try {
		await apiRMKTService.post("/fgtsColdSimulation", data);
	} catch (error) {
		throw new Error("Error on RMKT Service: RMTKColdSimulation");
	}
};

export const RMKTRotSimulation = async (data: RotSimulation): Promise<void> => {
	try {
		await apiRMKTService.post("/fgtsSimulation", data);
	} catch (error) {
		throw new Error("Error on RMKT Service: RMTKRotSimulation");
	}
};
